import React, { useState } from 'react'
import './Admin.css'
import Admin_nav from '../../Admincomponents/Admin_nav/Admin_nav'
import Additems from '../../Admincomponents/Additems/Additems'
import Listitem from '../../Admincomponents/Listitem/Listitem'
import Orders from '../../Admincomponents/Orders/Orders'
import Reports from '../../Admincomponents/Reports/Reports'
import Panel from '../../Admincomponents/Panel/Panel'
import Statics from '../../Admincomponents/Statics/Statics'

function Admin() {
    const [display, setDisplay] = useState(1)

    return (
        <div className='admin_container'>
            <div className="admin_nav_container">
                <Admin_nav/>
            </div>
            <div className="user_body_container">
                <div className="bars">
                    <ul>
                        <li onClick={() => setDisplay(1)}>Dashboard</li>
                        <li onClick={() => setDisplay(2)}>Add items</li>
                        <li onClick={() => setDisplay(3)}>List items</li>
                        <li onClick={() => setDisplay(4)}>Orders</li>
                        <li onClick={() => setDisplay(5)}>Reports</li>
                        <li onClick={() => setDisplay(6)}>Admins</li>
                    </ul>
                </div>
                <div className="contents">
                    {display === 1 && <Statics/>}
                    {display === 2 && <Additems/>}
                    {display === 3 && <Listitem/>}
                    {display === 4 && <Orders/>}
                    {display === 5 && <Reports/>}
                    {display === 6 && <Panel/>}
                </div>
            </div>
        </div>
    )
}

export default Admin